import {NgModule} from '@angular/core';
import {ContinuingMedicalEducationService} from './continuing-medical-education.service';
import {ContinuingMedicalEducationInformationService} from './continuing-medical-education-information.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [ContinuingMedicalEducationService, ContinuingMedicalEducationInformationService]
})
export class ContinuingMedicalEducationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/cme/continuing-medical-education.module.ts